import type { Translation } from '../i18n-types';

const pt: Translation = {
  userGuide: 'User Guide',
  privacyPolicy: 'Privacy Policy',
  termsConditions: 'Terms & Conditions',
  support: 'Support',
  abandoned: 'Abandonado',
  completed: 'Concluído',
  cancelled: 'Cancelado',
  ended: 'Finalizado',
  actionComments: 'Comentários da ação',
  actionItem: 'Item de ação',
  actionItemPlaceholder: 'Item de ação...',
  actionItems: 'Itens de ação',
  actionPhaseDescription: 'Adicione itens de ação, você não pode mais agrupar ou votar em comentários',
  actions: 'Ações',
  activate: 'Ativar',
  active: 'Ativo(a)',
  activeRetros: 'Retros ativas',
  activeRetroUsers: 'Usuários ativos da Retro',
  activeStoryboards: 'Storyboards ativos',
  activeStoryboardUsers: 'Usuários ativos do Storyboard',
  addComment: 'Adicionar comentário',
  addPersona: 'Adicionar Persona',
  admin: 'Admin',
  adminCleanOldRetros: 'Limpar Retros com mais de {daysOld} dias',
  adminCleanOldStoryboards: 'Limpar Storyboards com mais de {daysOld} dias',
  adminPageAdmin: 'Admin',
  adminPageAlerts: 'Alertas',
  adminPageApi: 'Chaves de API',
  adminPageOrganizations: 'Organizações',
  adminPageTeams: 'Equipes',
  adminPageUsers: 'Usuários',
  adminPageSubscriptions: 'Subscriptions',
  deleteSubscriptionConfirmation: 'Are you sure you want to delete this subscription?',
  deleteSubscription: 'Delete Subscription',
  alertAllowDismiss: 'Permitir dispensar',
  alertContent: 'Conteúdo do Alerta',
  alertContentPlaceholder: 'Digite um conteúdo para o alerta',
  alertCreate: 'Criar alerta',
  alertDelete: 'Excluir alerta',
  alertDeleteConfirmation: 'Tem certeza de que deseja excluir este alerta?',
  alertNamePlaceholder: 'Insira um nome de alerta',
  alertRegisteredOnly: 'Somente registrado',
  alerts: 'Alertas',
  alertSave: 'Salvar alerta',
  alertTypePlaceholder: 'Selecione um tipo de alerta',
  allVotesIn: 'Todos os votos em',
  apiDocumentation: 'Documentação de API',
  apikeyCopyFailure: 'Não foi possível copiar a chave de API para a área de transferência',
  apikeyCopySuccess: 'Chave de API copiada para a área de transferência',
  apiKeys: 'Chaves de API',
  applicationStatsError: 'Erro ao obter estatísticas do aplicativo',
  appName: 'Thunderdome',
  appPreviewAlt: 'Prévia do Thunderdome, um Planning Poker Agile com Experiência de UI',
  appSubtitle: 'Aplicação de Planning Poker Agile de Código Aberto',
  appVersion: 'versão {version}',
  associateTeam: 'Equipe Associada',
  authError: 'Erro encontrado ao tentar autenticar o jogador',
  autoFinishVoting: 'Finalização automática de votação',
  avatarAltText: 'Espaço reservado para o Avatar',
  back: 'Voltar',
  battleAbandon: 'Abandonar jogo',
  battleCreate: 'Criar jogo',
  battleDelete: 'Excluir jogo',
  battleEdit: 'Editar jogo',
  battleEditPointsDisabled: 'A votação está ativa, não é possível modificar os pontos permitidos.',
  battleJoin: 'Entrar no jogo',
  battleName: 'Nome do jogo',
  battleRemoveError: 'Erro ao tentar remover o jogo.',
  battleRemoveSuccess: 'Jogo removido com sucesso.',
  battles: 'Jogos',
  battlesActive: 'Jogos ativos',
  battlesActiveUsers: 'Usuários ativos do jogo',
  becomeFacilitator: 'Tornar-se Facilitador',
  becomeParticipant: 'Tornar-se Participante',
  becomeSpectator: 'Tornar-se Espectador',
  blocked: 'Bloqueado',
  blockers: 'Impedimentos',
  blockersPlaceholder: 'Estou impedido por...',
  brainstorm: 'Brainstorm',
  brainstormPhaseDescription: 'Adicione seus comentários abaixo',
  brainstormPhaseFeedbackVisibility: 'Visibilidade do feedback na fase de brainstorming',
  brainstormVisibilityLabelConcealed: 'Feedback escondido',
  brainstormVisibilityLabelHidden: 'Feedback oculto',
  brainstormVisibilityLabelVisible: 'Feedback visível',
  cancel: 'Cancelar',
  cannotBeUndone: 'Isto não pode ser desfeito.',
  checkIn: 'Check-in',
  checkinCommentDeleteError: 'Erro ao excluir check no comentário',
  checkinCommentError: 'Erro ao comentar no check-in',
  checkinError: 'Erro ao fazer check-in',
  checkinMeetYesterdayGoalsQuestion: 'Você atingiu os objetivos de ontem?',
  checkins: 'Check-ins',
  colorLegend: 'Legenda de cores',
  colorLegendNotSpecified: 'legenda não especificada',
  comment: 'Comentar',
  comments: 'Comentários',
  conciseVotingResults: 'Resultados Concisos da Votação',
  confirmDeleteRetro: 'Tem certeza de que deseja excluir esta retrospectiva?',
  createAccount: 'Criar conta',
  createAccountTagline: `Don't have an account?`,
  createAlertError: 'Erro ao criar alerta',
  createAlertSuccess: 'Alerta criado com sucesso',
  createARetro: 'Criar uma Retro',
  createAStoryboard: 'Criar um Storyboard',
  createBattleError: 'Erro encontrado ao criar o jogo',
  createOrgError: 'Erro tentar criar organização',
  createRetro: 'Criar Retro',
  createRetroErrorMessage: 'Erro encontrado ao criar retro',
  createStoryboard: 'Criar Storyboard',
  createUserError: 'Erro ao criar usuário',
  customizableBattleOptions: 'Opções de jogo personalizáveis',
  dateCreated: 'Data de criação',
  dateUpdated: 'Data de atualização',
  delete: 'Excluir',
  deleteActionItemError: 'Erro ao excluir o item de ação',
  deleteActionItemSuccess: 'Item de ação excluído com sucesso',
  deleteAlertError: 'Erro ao tentar excluir alerta',
  deleteAlertSuccess: 'Alerta excluído com sucesso',
  deleteBattle: 'Excluir jogo',
  deleteBattleConfirmText: 'Tem certeza de que deseja excluir este jogo?',
  deleteBattleError: 'error deleting game',
  deleteCheckinError: 'Erro ao excluir check-in',
  deleteDepartment: 'Excluir departamento',
  deleteDepartmentConfirmText: 'Tem certeza de que deseja excluir este departamento?',
  deleteOrganization: 'Excluir organização',
  deleteOrganizationConfirmText: 'Tem certeza de que deseja excluir esta organização?',
  deleteRetro: 'Excluir Retro',
  deleteRetroErrorMessage: 'erro ao deletar retrospectiva',
  deleteStoryboard: 'Excluir Storyboard',
  deleteStoryboardErrorMessage: 'erro ao deletar storyboard',
  deleteTeam: 'Excluir equipe',
  deleteTeamConfirmText: 'Tem certeza de que deseja excluir esta equipe?',
  deleteUserError: 'Erro ao tentar excluir usuário',
  demote: 'Rebaixar',
  demoteUserError: 'Erro ao rebaixar usuário',
  department: 'Departamento',
  departmentCreate: 'Criar departamento',
  departmentCreateError: 'Erro ao tentar criar departamento',
  departmentDeleteError: 'Erro ao tentar excluir departamento',
  departmentDeleteSuccess: 'Departamento excluído com sucesso.',
  departmentGetError: 'Erro ao obter departamento',
  departmentName: 'Nome do departamento',
  departmentNamePlaceholder: 'Digite o nome do departamento',
  departments: 'Departamentos',
  departmentSave: 'Salvar departamento',
  departmentTeamsGetError: 'Erro ao obter as equipes do departamento',
  departmentUsersGetError: 'Erro ao obter os usuários do departamento',
  discuss: 'Discutir',
  discussPlaceholder: 'Gostaria de discutir...',
  done: 'Feito',
  duplicateRetroSession: 'Existe uma sessão retro duplicada para o seu ID',
  duplicateStoryboardSession: 'Existe uma sessão de storyboard duplicada para seu ID',
  edit: 'Editar',
  editColorLegend: 'Editar Legenda',
  editRetro: 'Editar Retro',
  editStoryboard: 'Editar Storyboard',
  email: 'Email',
  enterPasscode: 'Digite o código de acesso...',
  enterYourEmail: 'Digite seu email',
  execute: 'Executar',
  export: 'Exportar',
  facilitator: 'Facilitador',
  facilitatorCode: 'Código do facilitador',
  facilitatorCodeOptional: 'Código do facilitador (opcional)',
  facilitatorCodePlaceholder: 'Insira um código opcional de facilitador',
  finalPoints: 'Pontos finais',
  flag: 'Indicador',
  footerAuthoredBy: 'Feito com ❤️ por {authorOpen}Steven Weathers{authorClose}',
  forgotPassword: 'Forgot Your Password?',
  forgotPasswordSubtext: `Don't fret! Just enter your email and we will send you instructions to reset your password.`,
  returnToLogin: 'Return to Login',
  getAlertsError: 'Erro ao obter alertas',
  getApikeysError: 'Erro ao obter chaves de API',
  getBattleError: 'Erro ao obter jogo',
  getBattlesError: 'Erro ao obter jogos',
  getCheckinsError: 'Erro ao obter o check-ins',
  getOrganizationsError: 'Erro ao obter organizações',
  getRetroErrorMessage: 'Erro ao obter retro',
  getRetrosErrorMessage: 'Erro ao obter retros',
  getStoryboardErrorMessage: 'Erro ao obter storyboard',
  getStoryboardsErrorMessage: 'Erro ao obter storyboards',
  getTeamsError: 'Erro ao obter equipes',
  getUserError: 'Erro ao obter usuário',
  getUsersError: 'Erro ao obter usuários',
  goalsMet: 'Objetivos atingidas',
  goalsNotMet: 'Objetivos não atingidos',
  group: 'Grupo',
  groupName: 'Nome do grupo',
  groupPhaseDescription: 'Arraste e solte comentários para agrupá-los',
  hostedDesc: '{linkOpen}Thunderdome.dev{linkClose} é um serviço hospedado gratuito (SaaS) sem anúncios.',
  hostedOrSelfHosted: 'Serviço hospedado ou auto-hospedado',
  importCsv: 'Importar stories de um arquivo CSV',
  importCsvFileBadFileTypeError: 'Erro, tipo de arquivo não suportado',
  importCsvFileReadFileError: 'Erro ao ler o arquivo',
  importJiraXML: 'Importar histórias de XML do Jira',
  importJiraXMLBadFileTypeError: 'Tipo de arquivo incorreto',
  importJiraXMLReadFileError: 'Erro ao ler o arquivo',
  incorrectPassCode: 'Código de acesso incorreto',
  inviteLinkCopyFailure: 'Não foi possível copiar o link do convite para a área de transferência',
  inviteLinkCopySuccess: 'Link de convite copiado para a área de transferência',
  jiraXmlImport: 'Importação XML do Jira',
  joinCodeCopyFailure: 'Não foi possível copiar o código de acesso para a área de transferência',
  joinCodeCopySuccess: 'Código de acesso copiado para a área de transferência',
  joinCodeLabelOptional: 'Código de acesso (opcional)',
  joinCodePlaceholder: 'Digite o código de acesso',
  joinRetro: 'Junte-se a Retro',
  joinStoryboard: 'Junte-se ao storyboard',
  joinStoryboardError: 'Erro ao ingressar no storyboard, atualize e tente novamente.',
  landingCountries: 'Usuários em mais de {count} países',
  landingFeatureOpenSourceText:
    'Confira o {repoOpen}repositório no GitHub{repoClose} para solicitar ou contribuir com melhorias, traduções de localidades e correções de bugs ou para {donateOpen}Doar{donateClose}.',
  landingFeatureOpenSourceTitle: 'Código aberto',
  landingSalesPitch:
    'Colaboração de equipes remotas com agile story pointing, retrospectiva de sprint, story mapping e check-in assíncrono da equipe.',
  landingTitle: 'Thunderdome é um aplicativo ágil de Planning Poker com um tema divertido',
  lastActive: 'Ativo pela última vez',
  leaveRetro: 'Sair da Retro',
  leaveStoryboard: 'Sair do Storyboard',
  legendRetroPlaceholder: 'Digite a legenda para a cor',
  loadingRetro: 'Carregando Retro...',
  loadingStoryboard: 'Carregando Storyboard...',
  login: 'Login',
  loginForRetro: 'ou {loginOpen}Login{loginClose} para juntar-se à retro',
  loginForStoryboard: 'ou {loginOpen}Login{loginClose} para entrar no storyboard',
  logout: 'Sair',
  logoutError: 'Erro encontrado ao tentar fazer logout do usuário',
  makeFacilitator: 'Tornar Facilitador',
  mfa2faLabel: 'Autenticação 2FA/MFA',
  mfa2faRemove: 'Remover 2FA/MFA',
  mfa2faRemoveFailure: 'Falha ao remover 2FA/MFA',
  mfa2faRemoveSuccess: '2FA/MFA removido com sucesso',
  mfa2faRemoveText: 'Tem certeza que quer remover 2FA/MFA?',
  mfa2faSetup: 'Configurar 2FA/MFA',
  mfaAuthError: 'Erro ao validar o token do autenticador',
  mfaConfirmToken: 'Confirme o token',
  mfaGenerateFailed: 'falha ao iniciar a configuração 2FA/MFA',
  mfaSecretKeyLabel: 'Chave secreta',
  mfaSetupFailed: 'falha ao validar o token de configuração 2FA/MFA',
  mfaSetupIntro:
    'Digitalize o código QR a seguir com um aplicativo autenticador (como Google Authenticator ou Authy) e insira o token gerado.',
  mfaSetupSuccess: '2FA/MFA ativado com sucesso',
  mfaTokenLabel: 'Token do autenticador',
  mfaTokenPlaceholder: 'Insira o token do aplicativo autenticador',
  myRetros: 'Minhas Retros',
  myStoryboards: 'Meus Storyboards',
  name: 'Nome',
  needsImprovement: 'Precisa de melhorias',
  nextPhase: 'Próxima Fase',
  noComments: 'Sem comentários...',
  oldBattleCleanError: 'Erro encontrado ao limpar jogos',
  oldGuestsCleanError: 'Erro encontrado ao limpar convidados',
  oldRetrosCleanError: 'Erro ao tentar limpar retros',
  oldStoryboardsCleanError: 'Erro ao tentar limpar storyboards',
  openSource: 'Código aberto',
  optional: '(Opcional)',
  optionalLeadercodePlaceholder: 'Código de acesso (opcional) de líder',
  optionalPasscodePlaceholder: 'Código de acesso opcional para participar',
  organization: 'Organização',
  organizationCreate: 'Criar organização',
  organizationDeleteError: 'Erro ao tentar excluir a organização',
  organizationDeleteSuccess: 'Organização excluída com sucesso',
  organizationGetDepartmentsError: 'Erro ao obter departamentos da organização',
  organizationGetError: 'Erro ao obter a organização',
  organizationGetTeamsError: 'Erro ao obter equipes da organização',
  organizationGetUsersError: 'Erro ao obter usuários da organização',
  organizationName: 'Nome da organização',
  organizationNamePlaceholder: 'Digite o nome da organização',
  organizations: 'Organizações',
  organizationsAndTeams: 'Organizações e Equipes',
  organizationSave: 'Salvar organização',
  owner: 'Proprietário',
  participation: 'Participação',
  passCode: 'Código de acesso',
  passCodeRequired: 'Código de acesso necessário para participar',
  personas: 'Personas',
  planAcceptanceCriteria: 'Critérios de Aceitação',
  planAcceptanceCriteriaPlaceholder: 'Insira os critérios de aceitação',
  planAdd: 'Adicionar história',
  planDescription: 'Descrição',
  planDescriptionPlaceholder: 'Digite uma descrição',
  planLink: 'Link',
  planLinkInvalid: 'O link não é um URL absoluto válido. Ex. deve incluir protocolo (HTTP/HTTPS)',
  planLinkPlaceholder: 'Insira um link para a história',
  planName: 'Nome da História',
  planNamePlaceholder: 'Digite o nome da história',
  planPriority: 'Prioridade',
  planPriorityBlocker: 'Impedimento',
  planPriorityHigh: 'Alta',
  planPriorityHighest: 'Máxima',
  planPriorityLow: 'Baixa',
  planPriorityLowest: 'Mínima',
  planPriorityMedium: 'Média',
  planPriorityPlaceholder: 'Selecione uma prioridade',
  planReferenceId: 'ID de referência',
  planReferenceIdPlaceholder: 'Insira um ID de referência',
  plans: 'Histórias',
  planSkip: 'Pular Story',
  planType: 'Tipo de História',
  planTypeBug: 'Bug',
  planTypeEpic: 'Épico',
  planTypePlaceholder: 'Tipos',
  planTypeSpike: 'Spike',
  planTypeStory: 'História',
  planTypeSubtask: 'Subtarefa',
  planTypeTask: 'Tarefa',
  pointAverageRounding: 'Arredondamento médio de pontos',
  pointed: 'Pontuado ({count})',
  points: 'Pontos',
  pointValuesAllowed: 'Valores de pontos permitidos',
  postComment: 'Postar comentário',
  primeDirective: 'Primeira Diretriz',
  promote: 'Promover',
  promoteUserError: 'Ocorreu um erro ao promover o usuário',
  questions: 'Perguntas',
  register: 'Registrar',
  reloadingRetro: 'Oops, recarregando Retro...',
  reloadingStoryboard: 'Oops, recarregando Storyboard...',
  remove: 'Remover',
  removeBattle: 'Remover jogo',
  removeBattleConfirmText: 'Tem certeza de que deseja remover este jogo?',
  removeRetro: 'Remover Retro',
  removeRetroConfirmText: 'Tem certeza de que deseja remover este retro?',
  removeStoryboard: 'Remove Storyboard',
  removeStoryboardConfirmText: 'Tem certeza de que deseja remover este storyboard?',
  removeUser: 'Remove usuário',
  removeUserConfirmText: 'Tem certeza de que deseja remover este usuário?',
  requestVerifyEmail: 'Solicitar e-mail de verificação',
  requestVerifyEmailFailure: 'Erro ao enviar e-mail de verificação',
  requestVerifyEmailSuccess: 'E-mail de verificação enviado, observe sua caixa de entrada',
  retro: 'Retro',
  retroActionCommentAddError: 'erro ao adicionar comentário de ação retro',
  retroActionCommentDeleteError: 'erro ao excluir comentário de ação retro',
  retroActionCommentEditError: 'erro ao editar comentário de ação da retro',
  retroActionItems: 'Itens de ação da Retro',
  retroAddError: 'Erro ao tentar adicionar retro.',
  retroAddSuccess: 'Retro adicionado com sucesso.',
  retroDeleted: 'Retro excluído',
  retroFeedbackConcealed: 'Feedback escondido',
  retroFeedbackHidden: 'Feedback oculto',
  retroImprovePlaceholder: 'O que precisa melhorar...',
  retroItems: 'Itens da Retro',
  retroJoinError: 'Erro ao ingressar no retro, atualize e tente novamente.',
  retroMaxVotesPerUserLabel: 'Máximo de votos do grupo (por usuário)',
  retroName: 'Nome da retro',
  retroNamePlaceholder: 'Digite o nome da retro',
  retroQuestionPlaceholder: 'Eu quero perguntar...',
  retroRemoveError: 'Erro ao tentar remover a retrospectiva.',
  retroRemoveSuccess: 'Retrospectiva removida com sucesso.',
  retros: 'Retrospectivas',
  retroWorkedPlaceholder: 'O que funcionou bem...',
  role: 'Função',
  rolePlaceholder: 'Selecione a função dos usuários',
  save: 'Salvar',
  search: 'Pesquisar',
  searchLengthError: 'O valor da pesquisa deve ter pelo menos 3 caracteres',
  selectTeam: 'Selecione uma Equipe',
  selfHostedDesc: 'Alternativamente, você pode {linkOpen}executá-lo em seu próprio servidor{linkClose}.',
  sessionDuplicate: 'Existe uma sessão de jogo duplicada para o seu ID',
  showActiveBattles: 'Mostrar jogos ativos',
  showActiveRetros: 'Mostrar retros ativos',
  showActiveStoryboards: 'Mostrar storyboards ativos',
  showBlockedCheckins: 'Mostrar apenas check-ins que exigem discussão',
  showCompletedActionItems: 'Mostrar itens de ação concluídos',
  showVoters: 'Mostrar votantes',
  skipped: 'Ignorado',
  spectator: 'Espectador',
  storyboard: 'Storyboard',
  storyboardAddColumn: 'Adidionar Coluna',
  storyboardAddError: 'Erro ao tentar adicionar storyboard.',
  storyboardAddGoal: 'Adicionar objetivo',
  storyboardAddStoryToColumn: 'Adicionar história à coluna',
  storyboardAddSuccess: 'Storyboard adicionado com sucesso.',
  storyboardColumns: 'Colunas do Storyboard',
  storyboardDeleted: 'Storyboard excluído',
  storyboardEditColumn: 'Editar Coluna',
  storyboardGoalName: 'Nome do objetivo',
  storyboardGoalNamePlaceholder: 'Digite o nome do objetivo',
  storyboardGoals: 'Objetivos do Storyboard',
  storyboardPersonas: 'Personas do Storyboard',
  storyboardRemoveError: 'Erro ao tentar remover o storyboard.',
  storyboardRemoveSuccess: 'Storyboard removido com sucesso.',
  storyboards: 'Storyboards',
  storyboardStories: 'Histórias do Storyboard',
  columnPersonasTitle: 'Personas da Coluna',
  columnPersonasEmpty: 'Nenhuma persona adicionada a esta coluna',
  availablePersonas: 'Personas Disponíveis',
  availablePersonasEmpty: 'Nenhuma persona disponível',
  allPersonasAdded: 'Todas as personas foram adicionadas a esta coluna',
  team: 'Equipe',
  teamCheckins: 'Acompanhamento da Equipe',
  teamCreate: 'Criar equipe',
  teamCreateError: 'Erro ao tentar criar equipe.',
  teamCreateSuccess: 'Equipe criada com sucesso.',
  teamDeleteError: 'Erro ao tentar excluir equipe',
  teamDeleteSuccess: 'Equipe excluída com sucesso.',
  teamGetBattlesError: 'Erro ao obter jogos de equipe',
  teamGetError: 'Erro ao obter equipe',
  teamGetRetroActionsError: 'erro ao obter ações retro',
  teamGetRetrosError: 'Erro ao obter retros da equipe',
  teamGetStoryboardsError: 'Erro ao obter storyboards da equipe',
  teamGetUsersError: 'Erro ao obter usuários da equipe',
  teamName: 'Nome da equipe',
  teamNamePlaceholder: 'Digite o nome da equipe',
  teams: 'Equipes',
  teamSave: 'Salvar equipe',
  teamUserRequiredToCheckin: 'O usuário deve estar em alguma equipe para fazer o check-in',
  teamUserRequiredToComment: 'O usuário deve estar em alguma equipe para comentar',
  today: 'Hoje',
  todayPlaceholder: 'Hoje eu irei...',
  totalPoints: 'Total',
  totalVotes: 'Total de votos',
  type: 'Tipo',
  unknownWarrior: 'Jogador desconhecido',
  unpointed: 'Sem pontuação ({count})',
  updateActionItemError: 'Erro ao atualizar o item de ação',
  updateActionItemSuccess: 'Item de ação atualizado com sucesso',
  updateAlertError: 'Erro ao atualizar alerta',
  updateAlertSuccess: 'Alerta atualizado com sucesso',
  updateCheckinError: 'Erro ao atualizar check-in',
  updateComment: 'Atualizar comentário',
  userAdd: 'Adicionar usuário',
  userAddError: 'Erro ao tentar adicionar usuário.',
  userAddSuccess: 'Usuário adicionado com sucesso.',
  userEmail: 'E-mail do usuário',
  userEmailPlaceholder: 'Enter the users email',
  userName: 'Nome de Usuário',
  userRemoveError: 'Erro ao tentar remover usuário.',
  userRemoveSuccess: 'Usuário removido com sucesso.',
  users: 'Usuários',
  verifyAccount: 'Verificar conta',
  verifyAccountFailedError:
    'Ocorreu um erro ao verificar sua conta, talvez este link tenha expirado ou já tenha sido usado.',
  verifyAccountFailedTitle: 'Falha na verificação',
  verifyAccountLoading: 'Verificando conta...',
  verifyAccountVerifiedThanks: 'Obrigado por verificar seu e-mail.',
  verifyAccountVerifiedTitle: 'Conta verificada',
  view: 'Visualizar',
  vote: 'Voto',
  voteCount: 'Contagem de votos',
  votePhaseDescription: 'Vote nos grupos que você gostaria de discutir mais',
  voteResultsAverage: 'Média',
  voteResultsHighest: 'Mais alto',
  votingFinish: 'Encerrar votação',
  votingLocked: 'Votação bloqueada',
  votingRestart: 'Recomeçar votação',
  warriorCreate: 'Criar usuário',
  warriorInvite: 'Convide um jogador',
  warriorNudge: 'Cutucar',
  works: 'Funciona',
  writeCommentPlaceholder: 'Escreva um comentário...',
  yesterday: 'Ontem',
  yesterdayPlaceholder: 'Ontem eu...',
  yourRetros: 'Suas Retros',
  yourStoryboards: 'Seus Storyboards',
  addPlan: 'Adicionar história',
  battleNamePlaceholder: 'Digite o nome do jogo',
  autoFinishVotingLabel: 'Terminar a votação automaticamente quando todos os jogadores tiverem votado',
  averageRoundingOptions: {
    ceil: 'Para cima (teto)',
    floor: 'Para baixo (chão)',
    round: 'Com base nos decimais (arredondar)',
  },
  apiKeyCreateButton: 'Criar chave de API',
  apiKeyPrefix: 'Prefixo da chave',
  lastUpdated: 'Última atualização',
  apiKeysErrorRetrieving: 'Falha ao obter chaves de API',
  apiKeyDeleteSuccess: 'Chave de API excluída',
  apiKeyDeleteFailed: 'Falha ao excluir chave de API',
  apiKeyUpdateSuccess: 'Chave de API atualizada',
  apiKeyUpdateFailed: 'Falha ao atualizar chave de API',
  deactivate: 'Desativar',
  profileErrorRetrieving: 'Erro ao obter seu perfil',
  profileErrorUpdating: 'Erro ao tentar atualizar seu perfil',
  profileUpdateSuccess: 'Perfil atualizado',
  passwordUpdated: 'Senha atualizada.',
  passwordUpdateError: 'Erro ao tentar atualizar a senha',
  profileDeleteError: 'Erro encontrado ao tentar excluir sua conta.',
  profileTitle: 'Seu perfil',
  profile: 'Profile',
  updatePassword: 'Atualizar senha',
  deleteAccount: 'Excluir conta',
  deleteAccountWarningStatement: 'Tem certeza de que deseja excluir sua conta?',
  deleteConfirmButton: 'Confirmar',
  apiKeyNameInvalid: 'Por favor, digite um nome para a chave',
  apiKeyCreateSuccess: 'Nova chave de API {keyName} criada e {onlyNowOpen}será exibida somente agora{onlyNowClose}',
  apiKeyStoreWarning:
    'Por favor, armazene-o em algum lugar seguro porque assim que você sair desta página, não poderemos recuperar ou restaurar este token gerado.',
  apiKeyLimitReached: 'Você tem o número máximo de chaves de API permitidas.',
  apiKeyUnverifiedUser: 'Somente usuários registrados verificados podem criar chaves de API.',
  apiKeyCreateFailed: 'Falha ao criar chave de API',
  apiKeyName: 'Nome da chave',
  apiKeyNamePlaceholder: 'Digite o nome da chave',
  create: 'Criar',
  close: 'Fechar',
  country: 'País',
  company: 'Empresa',
  verified: 'Verificado',
  registeredUsers: 'Usuários Registrados',
  myBattles: 'Meus jogos',
  createBattle: 'Criar um jogo',
  countPlansPointed: '{totalPointed} de {totalPlans} histórias pontuadas',
  myBattlesError: 'Erro ao encontrar seus jogos',
  warriorJoined: '{name} entrou no jogo',
  warriorRetreated: '{name} deixou o jogo',
  planSkipped: 'História ignorada',
  warriorVoted: '{name} votou',
  warriorRetractedVote: '{name} retirou o voto',
  battleDeleted: 'Jogo excluído',
  warriorNudgeMessage: 'tic tac... {name}, esperando você votar.',
  battle: 'Jogo',
  warriors: 'Jogadores',
  battleSocketReconnecting: 'Ooops, recarregando jogo...',
  battleSocketError: 'Erro ao entrar no jogo atualize e tente novamente.',
  battleLoading: 'Carregando jogo...',
  votingNotStarted: 'Votação não iniciada',
  password: 'Senha',
  passwordPlaceholder: 'Digite uma senha',
  yourPasswordPlaceholder: 'Digite sua senha',
  confirmPassword: 'Confirmar Senha',
  confirmPasswordPlaceholder: 'Confirme sua senha',
  update: 'Atualizar',
  reset: 'Redefinir',
  passwordResetError: 'Erro encontrado ao tentar redefinir a senha',
  resetPassword: 'Redefinir Senha',
  registerAsGuest: 'Registrar como Convidado',
  registrationDisabled: 'O cadastro está desativado.',
  userNamePlaceholder: 'Digite seu nome',
  guestRegisterError: 'Erro encontrado ao tentar registrar como convidado',
  registerError: 'Erro encontrado ao tentar registrar conta',
  enlistToBattle: 'Aliste-se para a Batalha',
  loginForBattle: 'ou {loginOpen}Entre{loginClose} para participar do Jogo',
  yourNamePlaceholder: 'Digite seu nome',
  createAccountFormTitle: 'Criar uma Conta {optionalOpen}(opcional){optionalClose}',
  sendResetPasswordSuccess: 'Instruções sobre como redefinir sua Senha enviadas para {email}',
  sendResetPasswordError: 'Erro encontrado ao tentar enviar a redefinição de senha',
  chooseCountryPlaceholder: 'Escolha seu país (opcional)',
  locale: 'Localidade',
  companyPlaceholder: 'Digite o nome de sua empresa (opcional)',
  jobTitle: 'Profissão',
  jobTitlePlaceholder: 'Digite sua profissão (opcional)',
  enableBattleNotifications: 'Ativar notificações do jogo',
  avatar: 'Avatar',
  updateProfile: 'Atualizar Perfil',
  guestUsers: 'Usuários Convidados',
  maintenance: 'Manutenção',
  cleanGuests: 'Limpar Convidados com mais de {daysOld} dias',
  cleanBattles: 'Limpar Jogos com mais de {daysOld} dias',
  chooseLocalePlaceholder: 'Escolha sua localidade preferida (opcional)',
  importPlans: 'Importar Stories',
  selectFile: 'selecionar arquivo...',
  theme: 'Tema',
  assignees: 'Responsáveis',
  assigneeSelectPlaceholder: 'Selecione um responsável para adicionar',
  assigneeAdd: 'Adicionar Responsável',
  allStoryWithCount: 'Todas ({count})',
  userUpdate: 'Atualizar Usuário',
  userUpdateSuccess: 'Usuário atualizado com sucesso.',
  userUpdateError: 'Erro ao atualizar usuário.',
  invites: 'Convites',
  userInvites: 'Convites de Usuário',
  userInviteSent: 'Convite de usuário enviado',
  userInviteConfirmDelete: 'Tem certeza de que deseja excluir este convite de usuário?',
  userInviteDelete: 'Excluir Convite',
  acceptInvite: 'Aceitar convite',
  rejectInvite: 'Rejeitar convite',
  rejectingInvite: 'Rejeitando...',
  inviteRejected: 'Convite rejeitado',
  inviteRejectError: 'Erro ao rejeitar convite',
  getUserInvitesError: 'Erro ao carregar os convites do usuário',
  expireDate: 'Data de Expiração',
  addUserWillInviteNotFoundFieldNote:
    'Se o usuário não estiver registrado, um convite para se registrar e participar do {pageType} será enviado.',
  inviteUserFieldNote: 'Um convite para participar do {pageType} será enviado.',
  requiresOrganizationMember: 'O usuário já deve estar na Organização.',
  teamUpdateSuccess: 'Time atualizado com sucesso',
  teamUpdateError: 'Erro ao atualizar Time',
  orgUpdateSuccess: 'Organização atualizada com sucesso',
  orgUpdateError: 'Erro ao atualizar Organização',
  deptUpdateSuccess: 'Departamento atualizado com sucesso',
  deptUpdateError: 'Erro ao atualizar Departamento',
  hideVoterIdentity: 'Ocultar Identidade do Votante',
  storyboardName: 'Nome do Storyboard',
  storyboardNamePlaceholder: 'Digite o nome do storyboard',
  retroPhaseTimeLimitMinLabel: 'Limite de tempo da fase de brainstorm em minutos',
  phaseAutoAdvanceLabel: 'Avançar fases automaticamente',
  removeOnlyFacilitatorError: 'Não é possível remover o único facilitador',
  noGamesFound: 'Nenhum jogo encontrado, tente criar um.',
  noRetrosFound: 'Nenhuma retro encontrada, tente criar uma.',
  noStoryboardsFound: 'Nenhum storyboard encontrado, tente criar um.',
  retroDescription:
    'Uma retrospectiva de sprint é uma revisão realizada após um sprint que desempenha um papel fundamental na metodologia Ágil. Uma retrospectiva de sprint visa determinar o que funcionou bem e onde você teve problemas, identificando áreas onde pode melhorar.',
  pokerDescription:
    'O scrum poker, também conhecido como "planning poker" e "pointing poker", é uma técnica gamificada que as equipes de desenvolvimento usam para estimar o esforço de tarefas de gerenciamento de projetos. Essas estimativas são baseadas na contribuição e consenso de todo o grupo, tornando-as mais envolventes e precisas do que outros métodos.',
  storyboardDescription:
    'O mapeamento de histórias de usuário (storyboard) é uma visualização da jornada que um cliente percorre com um produto, do início ao fim. Inclui todas as tarefas que normalmente completariam como parte dessa jornada.',
  estimationScaleNamePlaceholder: 'Digite o nome da escala',
  description: 'Descrição',
  estimationScaleDescriptionPlaceholder: 'Digite a descrição da escala',
  scaleType: 'Tipo de Escala',
  estimationScaleTypePlaceholder: 'Selecione o tipo de escala',
  scaleValues: 'Valores da Escala',
  estimationScaleValuesPlaceholder: 'Digite valores separados por vírgula',
  estimationScaleValuesHelp: 'Digite valores separados por vírgulas (ex: 1, 2, 3, 5, 8)',
  estimationScaleIsPublic: 'Tornar esta escala pública',
  estimationScaleDefault: 'Definir como escala padrão',
  estimationScaleSave: 'Salvar Escala',
  estimationScales: 'Escalas de Estimativa',
  estimationScaleCreate: 'Criar Escala de Estimativa',
  estimationScaleCreateSuccess: 'Escala de estimativa criada com sucesso',
  estimationScaleCreateError: 'Erro ao criar escala de estimativa',
  estimationScaleUpdateSuccess: 'Escala de estimativa atualizada com sucesso',
  estimationScaleUpdateError: 'Erro ao atualizar escala de estimativa',
  estimationScaleRemoveSuccess: 'Escala de estimativa removida com sucesso',
  estimationScaleRemoveError: 'Erro ao remover escala de estimativa',
  removeEstimationScaleConfirmText: 'Tem certeza de que deseja remover esta escala de estimativa?',
  removeEstimationScale: 'Remover Escala de Estimativa',
  yes: 'Sim',
  no: 'Não',
  isPublic: 'Público',
  default: 'Padrão',
  publicEstimationScales: 'Escalas de Estimativa Públicas',
  organizationEstimationScales: 'Escalas de Estimativa da Organização',
  teamEstimationScales: 'Escalas de Estimativa da Equipe',
  allowCumulativeVotingLabel: 'Permitir Votação Cumulativa (mais de 1 voto por grupo de item)',
  activeSubscriptions: 'Assinaturas Ativas',
  retroTemplates: 'Templates de Retro',
  publicRetroTemplates: 'Templates de Retro Públicos',
  organizationRetroTemplates: 'Templates de Retro da Organização',
  teamRetroTemplates: 'Templates de Retro da Equipe',
  retroTemplateNamePlaceholder: 'Digite o nome do template',
  retroTemplateDescriptionPlaceholder: 'Digite a descrição do template',
  format: 'Formato',
  retroTemplateIsPublic: 'Tornar este template público',
  retroTemplateSave: 'Salvar Template',
  retroTemplateCreate: 'Criar Template de Retrospectiva',
  retroTemplateCreateSuccess: 'Template de retrospectiva criado com sucesso',
  retroTemplateCreateError: 'Erro ao criar template de retrospectiva',
  retroTemplateUpdateSuccess: 'Template de retrospectiva atualizado com sucesso',
  retroTemplateUpdateError: 'Erro ao atualizar template de retrospectiva',
  retroTemplateRemoveSuccess: 'Template de retrospectiva removido com sucesso',
  retroTemplateRemoveError: 'Erro ao remover template de retrospectiva',
  removeRetroTemplateConfirmText: 'Tem certeza de que deseja remover este template de retrospectiva?',
  removeRetroTemplate: 'Remover Template de Retrospectiva',
  retroTemplateDefault: 'Definir como template padrão',
  jiradatacenterLabel: 'Jira DataCenter',
  loginWithSSO: 'Entrar com {provider}',
  requestEmailChangeSuccess:
    'Solicitação de alteração de e-mail enviada, verifique sua caixa de entrada para obter instruções',
  requestEmailChangeError: 'Erro ao tentar alterar o e-mail',
  changeEmail: 'Alterar E-mail',
  errorChangingEmail: 'Erro ao tentar alterar o e-mail, talvez este link tenha expirado ou já tenha sido usado.',
  emailChanged: 'E-mail alterado com sucesso',
  newEmailToLogin: 'A partir de agora, use seu novo e-mail para fazer login.',
  newEmail: 'Novo E-mail',
  enterYourNewEmail: 'Digite seu novo e-mail',
  retroSettings: 'Configurações da Retro',
  enterFacilitatorCode: 'Insira o Código do Facilitador',
  // Modal ariaLabels
  modalCreateAlert: 'Criar Alerta',
  modalUpdateEstimationScale: 'Atualizar Escala de Estimativa',
  modalDeleteConfirmation: 'Confirmar Exclusão',
  modalCreateEstimationScale: 'Criar Escala de Estimativa',
  modalTeamCheckin: 'Check-in da Equipe',
  modalAddPokerStory: 'Adicionar História do Poker',
  modalCreateUser: 'Criar Usuário',
  modalCreateApiKey: 'Criar Chave de API',
  modalImportPokerStories: 'Importar Histórias do Poker',
  modalSetupMultifactorAuth: 'Configurar Autenticação Multifator',
  modalEditPokerGame: 'Editar Jogo de Poker',
  modalCreateJiraInstance: 'Criar Instância do Jira',
  modalUpdatePokerSettings: 'Atualizar Configurações do Poker',
  modalAddStoryboardGoal: 'Adicionar Objetivo do Storyboard',
  modalViewPokerStory: 'Visualizar História do Poker',
  modalStoryboardColumnSettings: 'Configurações de Coluna do Storyboard',
  modalEditStoryboard: 'Editar Storyboard',
  modalStoryboardColorLegend: 'Legenda de Cores do Storyboard',
  modalStoryboardPersonas: 'Personas do Storyboard',
  modalRetroActionComments: 'Comentários de Ação da Retro',
  modalStoryboardStory: 'História do Storyboard',
  modalTeamAddUser: 'Adicionar Usuário à Equipe',
  modalCreateDepartment: 'Criar Departamento',
  modalCreateTeam: 'Criar Equipe',
  modalCreateOrganization: 'Criar Organização',
  modalCreateRetroTemplate: 'Criar Modelo de Retro',
  modalViewRetroTemplateFormat: 'Visualizar Formato do Modelo de Retro',
  modalUpdateRetroTemplate: 'Atualizar Modelo de Retro',
  modalAssociateTeamToSubscription: 'Associar Equipe à Assinatura',
  modalAssociateOrganizationToSubscription: 'Associar Organização à Assinatura',
  modalTeamUpdateUser: 'Atualizar Usuário da Equipe',
  modalSubscriptionForm: 'Formulário de Assinatura',
  modalEditRetro: 'Editar Retro',
  modalEditRetroActionItem: 'Editar Item de Ação da Retro',
  modalRetroItemComments: 'Comentários do Item da Retro',
  modalUpdateRetroSettings: 'Atualizar Configurações da Retro',
  githubRepository: 'Repositório GitHub',
  projects: 'Projetos',
  projectCreate: 'Criar Projeto',
  projectKey: 'Chave do Projeto',
  scope: 'Escopo',
  createdAt: 'Criado em',
  projectRemoveSuccess: 'Projeto removido com sucesso',
  projectRemoveError: 'Falha ao remover o projeto',
  removeProjectConfirmText: 'Tem certeza de que deseja remover este projeto? Esta ação não pode ser desfeita.',
  removeProject: 'Remover Projeto',
  modalCreateProject: 'Criar Projeto',
  modalUpdateProject: 'Atualizar Projeto',
  projectKeyPlaceholder: 'Digite a chave do projeto (ex. PROJ)',
  projectNamePlaceholder: 'Digite o nome do projeto',
  projectDescriptionPlaceholder: 'Digite a descrição do projeto (opcional)',
  projectKeyValidationError: 'A chave do projeto deve ter 2-10 caracteres alfanuméricos',
  projectKeyHelp: '2-10 caracteres, apenas letras e números',
  projectScope: 'Escopo do Projeto',
  projectUpdate: 'Atualizar Projeto',
  projectCreateSuccess: 'Projeto criado com sucesso',
  projectUpdateSuccess: 'Projeto atualizado com sucesso',
  projectCreateError: 'Falha ao criar projeto',
  projectUpdateError: 'Falha ao atualizar projeto',
  project: 'Projeto',
  gameSettings: 'Configurações do Jogo',
  endGame: 'Terminar Jogo',
  endGameReason: 'Razão para Terminar o Jogo',
  endGameReasonPlaceholder: 'Selecione uma razão',
  welcomeBack: 'Bem-vindo de volta,',
  dashboardSubtitle: 'Vamos fazer da sua próxima sessão de colaboração em equipe a melhor até agora.',
  filterByTeam: 'Filtrar por equipe:',
  allTeams: 'Todas as equipes',
  showContentForAllTeams: 'Mostrar conteúdo de todas as equipes',
  clearFilter: 'Limpar filtro',
  teamPage: 'Página da equipe',
  dashboardTeamsRequired: 'Selecione uma equipe para ver suas sessões de planning poker, retrospectivas e storyboards.',
  planningPokerSessions: 'Sessões de Planning Poker',
  viewAllPokerSessions: 'Ver todas as sessões de planning poker',
  totalPokerSessions: '{total} sessões no total',
  noSessionsFoundForTeam: 'Nenhuma sessão encontrada para {teamName}',
  noSessionsFound: 'Nenhuma sessão encontrada',
  trySelectingDifferentTeamForPoker: 'Tente selecionar uma equipe diferente ou criar um novo jogo',
  startFirstPlanningPokerSession: 'Inicie sua primeira sessão de planning poker',
  sprintRetrospectives: 'Retrospectivas de Sprint',
  viewAllRetros: 'Ver todas as retrospectivas',
  totalRetros: '{total} retrospectivas no total',
  noRetrosFoundForTeam: 'Nenhuma retrospectiva encontrada para {teamName}',
  startFirstSprintRetrospective: 'Inicie sua primeira retrospectiva de sprint',
  trySelectingDifferentTeamForRetros: 'Tente selecionar uma equipe diferente ou criar uma nova retrospectiva',
  viewAllStoryboards: 'Ver todos os storyboards',
  totalStoryboards: '{total} storyboards no total',
  noStoryboardsFoundForTeam: 'Nenhum storyboard encontrado para {teamName}',
  startFirstStoryboard: 'Inicie seu primeiro storyboard',
  agileStoryMapping: 'Mapeamento de Histórias Ágeis',
  trySelectingDifferentTeamForStoryboards: 'Tente selecionar uma equipe diferente ou criar um novo storyboard',
  supportTickets: 'Tickets de Suporte',
  supportTicketDeleteConfirmation:
    'Tem certeza de que deseja excluir este ticket de suporte? Esta ação não pode ser desfeita.',
  supportTicketDelete: 'Excluir Ticket',
  updateSupportTicketSuccess: 'Ticket de suporte atualizado com sucesso',
  updateSupportTicketError: 'Falha ao atualizar o ticket de suporte',
  getSupportTicketsError: 'Falha ao obter tickets de suporte',
  deleteSupportTicketSuccess: 'Ticket de suporte excluído com sucesso',
  deleteSupportTicketError: 'Falha ao excluir ticket de suporte',
  clear: 'Limpar',
};

export default pt;
